class CartUpsells extends HTMLElement {
    constructor() {
        super();
        this.init();
    }

    init() {
        this.fetchRequestOpts = {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        };

        this.addEventListener('change', this.handleChange.bind(this));
        this.addEventListener('submit', this.handleSubmit.bind(this));

        this.classList.add('upsells-initialized');
    }

    /**
     * Handles the change event.
     * @param {Event} evt - The event object.
     */
    handleChange(evt) {
        const checked = evt.target.checked;

        const form = evt.target.closest('form');

        const id = this.getId(form);

        if (checked) {
            this.addToCart(id);
        } else {
            this.removeFromCart(id);
        }
    }

    /**
     * Handles the submit event.
     * @param {Event} evt - The event object.
     */
    handleSubmit(evt) {
        evt.preventDefault();
        evt.submitter.classList.add('btn-loading');

        const form = evt.target;

        const id = this.getId(form);

        this.addToCart(id)
            .then(() => {
                evt.submitter.classList.remove('btn-loading');
            })
            .catch((err) => console.error('failed to handle submit for upsell: ', err));
    }

    /**
     * Fetches the ID input element.
     * @returns {HTMLInputElement} The ID input element.
     * @throws Will throw an error if the ID input element is not found.
     */
    getId(container) {
        const idInput = container.querySelector('input[name="id"]');
        if (!idInput) {
            throw new Error('ID input not found');
        }
        return idInput.value;
    }

    /**
     * Runs a fetch request to the specified URL with the current fetch request options.
     * @param {string} url - The URL to fetch.
     * @returns {Promise<Object>} The response data from the fetch request.
     * @throws Will throw an error if the fetch request fails.
     */
    async runCartFetch(url) {
        try {
            const response = await fetch(url, this.fetchRequestOpts);

            if (!response.ok) throw new Error(response.status);

            const data = await response.json();

            this.dispatchEvent(
                new CustomEvent('cart:updated', {
                    bubbles: true,
                    detail: {
                        cart: data,
                        initiator: 'cart-upsells'
                    }
                })
            );

            return data;
        } catch (error) {
            // Display error message
            let errorMessage = '';
            if (/^[0-9]+$/.test(error.message)) {
                errorMessage = 'Error occurred while changing cart, please try again.';
            } else {
                errorMessage = error.message;
            }
            console.error(error);

            if (errorMessage.length > 0) {
                // Optionally, display the error message to the user
            }

            return;
        }
    }

    /**
     * Adds an item to the cart.
     * @param {string} id - The ID of the item to add to the cart.
     * @returns {Promise<Object>} A promise that resolves when the item is added to the cart.
     */
    async addToCart(id) {
        VWO.event('upsellAddedToCart', { id });
        this.fetchRequestOpts.body = JSON.stringify({
            items: [
                {
                    quantity: 1,
                    id
                }
            ],
            sections: ['cart'],
            sections_url: window.location.pathname
        });

        return this.runCartFetch(window.Shopify.routes.root + 'cart/add.js');
    }

    /**
     * Removes an item from the cart.
     * @param {string} id - The ID of the item to remove.
     * @returns {Promise<Object>} The response data from the fetch request.
     * @throws Will throw an error if the fetch request fails.
     */
    async removeFromCart(id) {
        this.fetchRequestOpts.body = JSON.stringify({
            id,
            quantity: 0,
            sections: ['cart'],
            sections_url: window.location.pathname
        });

        return this.runCartFetch(window.Shopify.routes.root + 'cart/change.js');
    }
}

customElements.define('cart-upsells', CartUpsells);
